import { render } from "./FormCloneModal.vue?vue&type=template&id=1f0c8b9c&scoped=true&ts=true"
import script from "./FormCloneModal.vue?vue&type=script&lang=ts"
export * from "./FormCloneModal.vue?vue&type=script&lang=ts"

import "./FormCloneModal.vue?vue&type=style&index=0&id=1f0c8b9c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0c8b9c"]])

export default __exports__